import React from "react";
import m from '../assets/m.png';
import w from '../assets/w.png';
import d from '../assets/d.png';

const categories = [
  // {
  //   title: "Boys Singles",
  //   img: m,
  //   desc: "Open to beginner and advanced players. Ideal for those learning the game or competing with skill and confidence in fast-paced matches.",
  // },
  // {
  //   title: "Girls Singles",
  //   img: w,
  //   desc: "Suited for players at any level — from casual starters to skilled athletes ready for fun, challenge, and competitive rallies.",
  // },
  {
    title: "Doubles",
    img: d,
    desc: "Open to Men's, Women's, and Mixed teams. For beginners building teamwork or experienced duos playing with strategy and speed.",
  },
];

const CategoriesSection = () => (
  <section className="py-16 bg-white">
    <div className="max-w-7xl mx-auto px-4">
      <h2 className="text-4xl font-extrabold text-center text-red-600 mb-4">Play Your Way</h2>
      <p className="text-center text-lg text-gray-700 mb-12 max-w-3xl mx-auto">Whether you’re a seasoned pro or just stepping onto the court for the first time, our match categories are designed to give everyone a chance to play, compete, and enjoy the game.</p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
        {categories.map((cat, idx) => (
          <div key={idx} className="bg-white rounded-2xl shadow-lg p-6 flex flex-col items-center">
            <img src={cat.img} alt={cat.title} className="w-72 h-56 object-cover rounded-2xl mb-6" />
            <h3 className="text-2xl font-extrabold mb-2 text-gray-800 text-center">{cat.title}</h3>
            <p className="text-base text-gray-700 text-center">{cat.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default CategoriesSection; 